export enum CNMCStateEnum {
  DRAFT = 'draft',
  PROCESSING = 'processing',
  PROCESSED = 'processed',
  ERROR = 'error',
  CANCELLED = 'cancelled',
}

export enum CNMCFileStateEnum {
  UPLOADING = 'uploading',
  UPLOADED = 'uploaded',
}

export type CNMCFile = {
  id: string;
  created_at: string;
  uri: string;
  cnmc_id: string;
  created_by: string | null;
  presigned_url: string | null;
  state: CNMCFileStateEnum;
};

export type CNMC = {
  id: string;
  name: string;
  description: string;
  channel: string;
  provider: string;
  /**
   * Madrid wall clock with no offset — `2026-09-30T10:00:00.000` — not an
   * instant: the backend stores the text and forwards its fields to Media IA as
   * Spanish time. Read it with `parseAppWallClock`, write it with
   * `toAppWallClockString` (`@/utils/spain-time`); never with `new Date()`.
   */
  start_datetime: string;
  /** Madrid wall clock with no offset, as `start_datetime`. */
  end_datetime: string;
  recipients: string;
  files: CNMCFile[];
  state: CNMCStateEnum;
  created_by: string;
  created_at: string;
  updated_by: string | null;
  updated_at: string | null;
  report_id?: string;
  estimated_time: string | null;
};

export type CNMCForm = {
  name: string;
  description: string;
  channel: string;
  provider: string;
  start_datetime: Date;
  end_datetime: Date;
  state: CNMCStateEnum;
  recipients: string;
  review_state: string;
};

export type CNMCFilesUploadForm = {
  textFiles: File[];
  videoFiles: File[];
  companyActivityFiles: File[];
};

export type CNMCFilters = {
  id: string;
};
